module.exports = __webpack_public_path__ + "img/notes.c8a6d6e7.svg";